<template>
  <div class="settings">
    <h1 class="page-title">Settings</h1>

    <div class="page-content -column -column-one -form">
      <ul class="section-nav">
        <li v-for="section in sections" :key="section.slug" :class="{ '-active': isActiveSection(section) }">
          <router-link :to="`/settings/${section.slug}`">{{ section.label }}</router-link>
        </li>
      </ul>
    </div>

    <router-view :settings="settings"></router-view>
  </div>
</template>

<script>
import _ from "underscore";
import { mapGetters } from "vuex";

import auth from "@/helpers/auth";

export default {
  beforeRouteEnter(to, from, next) {
    if (!auth.signedIn()) return next("/sign-in");
    next();
  },

  data() {
    return {
      sections: [
        { slug: "widget", label: "Widget" },
        { slug: "conversations", label: "Conversations" },
        { slug: "initial-message", label: "Initial Message" },
        { slug: "query-overrides", label: "Query Overrides" },
        { slug: "bot-delays", label: "Bot Delays" },
        { slug: "webhooks", label: "Webhooks" },
        { slug: "matcher-thresholds", label: "Matcher Thresholds" },
        { slug: "context-filters", label: "Context Filters" },
        { slug: "blacklist-ips", label: "Blacklist IPs" },
        { slug: "api-access", label: "API Access" },
        { slug: "campaign", label: "Campaign" },
        { slug: "event-tracking", label: "Event Tracking" },
        { slug: "event-trackingGA4", label: "Event Tracking GA4" },
        { slug: "notifications", label: "Notifications" }
      ],
      settings: {}
    };
  },

  computed: {
    ...mapGetters(["currentTeam"])
  },

  watch: {
    currentTeam() {
      this.initSettings();
    }
  },

  created() {
    this.initSettings();
  },

  methods: {
    initSettings() {
      const initialSettings = (this.currentTeam || { settings: {} }).settings;

      this.settings = _.defaults(initialSettings, {
        widget_enabled: "true",
        webhook_url: "",
        webhook_signature_key: "",
        conversations_active_period: "5",
        classifier_pct: "65",
        keyword_pct: "35",
        match_threshold: "22",
        keyword_word_length_var: "10",
        keyword_threshold: "10",
        min_keyword_match: "30",
        min_negative_keyword_match: "90",
        classifier_threshold: "-15",
        read_delay_per_char: "20",
        write_delay_per_char: "50",
        context_filters: [],
        blacklisted_ips: [],
        whitelisted_timezones: [],
        ga_code: "",
        inline_number_query_id: "",
        inline_email_query_id: "",
        webhooks_pending_period: "5",
        notification_emails: []
      });
    },

    openSection(section) {
      this.$router.push(`/settings/${section.slug}`);
    },

    isActiveSection(section) {
      return this.$route.path === `/settings/${section.slug}`;
    }
  }
};
</script>
